<template>
  <div class="map-box">
    <el-amap
      vid="amapDemo"
      :plugin="plugin"
      :center="mapConfig.center"
      :zoom="mapConfig.zoom"
      class="amap-demo"
      :events="mapConfig.events"
    >
      <el-amap-marker
        :position="value"
        :visible="true"
        vid="index"
      ></el-amap-marker>
    </el-amap>
    <div class="toolbar">
      <span v-if="loaded"> location: lng = {{ lng }} lat = {{ lat }} </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
import cloneDeep from "lodash/cloneDeep";

// import { AMapManager } from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "87d98045766eb14b1fe94a5c4fa714bd",
  plugin: ["AMap.Autocomplete", "AMap.DragRoute"],
  // 默认高德 sdk 版本为 1.4.11
  v: "1.4.11",
});

let amapManager = new VueAMap.AMapManager();
// var thismarker, geocoder, toolBar;
export default {
  name: "mapSelect",
  props: {
    data: { type: Array },
  },
  model: {
    prop: "data",
    event: "updata",
  },
  data() {
    let self = this;
    return {
      amapManager,
      isMarker: false,
      mapConfig: {
        zoom: 14,
        center: [110.382412, 25.248137],
        events: {},
        // markers: [
        //   {
        //     position: [110.382412, 25.248137],
        //     events: {
        //       click: () => {
        //         alert("click marker");
        //       },
        //       dragend: e => {
        //         console.log("---event---: dragend");
        //         this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
        //       }
        //     },
        //     visible: true,
        //     draggable: false,
        //     template: "<span>1</span>"
        //   }
        // ]
      },
      value: [],
      lng: 0,
      lat: 0,
      loaded: false,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            },
          },
        },
      ],
    };
  },
  watch: {
    data() {
      this.copyData();
    },
  },
  created: function() {
    this.copyData();

    // var _this = this;
    // this.mapConfig.events.init = function(o) {
    //   // eslint-disable-next-line no-undef
    // thismarker = new AMap.Marker({});
    // if (_this.value && _this.value.length > 0) {
    //   //存在地区
    //   o.setZoomAndCenter(15, _this.value);
    //   _this.setManager(_this.value);
    // }
    // if (!geocoder) {
    //   // eslint-disable-next-line no-undef
    //   geocoder = new AMap.Geocoder({
    //     // city: "010", //城市设为北京，默认：“全国”
    //     resizeEnable: true,
    //     radius: 500 //范围，默认：500
    //   });
    // }
    // };
  },
  methods: {
    copyData() {
      this.value = cloneDeep(this.data);
      this.mapConfig.center = this.value;
    },
  },
};
</script>

<style lang="less" scoped>
.map-box {
  width: 100%;
  height: 5.5rem;
}
</style>
